<template>
  <div>
    <Select
      placeholder="请选择合作期刊"
      v-model="periodical.perName"
      filterable
      :clearable="true"
      :remote-method="remoteMethodP"
      :loading="loading"
      @on-change="periodicalsChange"
      style="width: 262px; margin-right: 10px"
    >
      <Option
        v-for="item in periodicalOptions"
        :key="item.pid"
        :value="item.name"
        >{{ item.name }}</Option
      >
    </Select>
  </div>
</template>

<script>
export default {
  name: "PeriodicalsSelect",
  props: {
    periodical: {
      type: Object,
    },
  },
  data() {
    return {
      loading: false,
      periodicalOptions: [],
    };
  },
  methods: {
    // 合作期刊下拉框远程搜索
    async remoteMethodP(query) {
      this.loading = true;
      let res = await this.$apis.userServe.journalOptions({
        periodicalName: query,
      });
      this.periodicalOptions = res.data.list;
      this.loading = false;
    },

    // 合作期刊选中后添加期刊名字
    periodicalsChange(query) {
      if (query === undefined) {
        this.periodical.perId = null;
        this.periodical.perName = null;
      } else {
        const arr = this.periodicalOptions.filter((item) => item.name === query);
        this.periodical.perId = arr[0].pid;
      }
    },
  },
};
</script>

<style>
</style>